__turbopack_context__.v({
  "blur-image": "style-module-scss-module__9NWmdG__blur-image",
  "bottom-content": "style-module-scss-module__9NWmdG__bottom-content",
  "component": "style-module-scss-module__9NWmdG__component",
  "exp": "style-module-scss-module__9NWmdG__exp",
  "image": "style-module-scss-module__9NWmdG__image",
  "link": "style-module-scss-module__9NWmdG__link",
  "price-and-timestamp-row": "style-module-scss-module__9NWmdG__price-and-timestamp-row",
  "private": "style-module-scss-module__9NWmdG__private",
  "pvr-date": "style-module-scss-module__9NWmdG__pvr-date",
  "row": "style-module-scss-module__9NWmdG__row",
  "street-address": "style-module-scss-module__9NWmdG__street-address",
  "tag": "style-module-scss-module__9NWmdG__tag",
  "wrapper": "style-module-scss-module__9NWmdG__wrapper",
});
